<template lang="html">
	<div class="omapi-card-setting-section" :class="{ disabled: !connected || !apiKeyValid }">
		<header>
			<h3>WooCommerce</h3>
		</header>
		<form v-if="!isWooConnected" @submit.prevent="connectWoo">
			<p>
				In order to integrate WooCommerce with our Display Rules, OptinMonster needs
				<a :href="$urls.wpAdmin('?page=wc-settings&tab=advanced&section=keys')"
					>WooCommerce REST API credentials</a
				>
				with Read Access Permissions.
			</p>

			<core-alert v-if="requestFail" :closes="true" type="error">
				WooCommerce REST API keys could not be auto-generated on your behalf. Please try creating them manually
				and entering them here.
			</core-alert>

			<div v-if="showWooSettings" class="omapi-flex">
				<div class="omapi-flex-child omapi-input-wrap">
					<common-tooltip tooltip="Format: ck_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX">
						<label>Consumer Key:</label>
					</common-tooltip>
					<input
						v-model="key"
						type="password"
						class="omapi-input"
						placeholder="Enter your consumer key here..."
					/>
				</div>
				<div class="omapi-flex-child omapi-input-wrap">
					<common-tooltip tooltip="Format: cs_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX">
						<label>Consumer Secret:</label>
					</common-tooltip>

					<input
						v-model="secret"
						type="password"
						class="omapi-input"
						placeholder="Enter your consumer secret here..."
					/>
				</div>
			</div>

			<core-save-button
				size="large"
				:color="wooLoading ? '' : 'blue'"
				style="margin-bottom: 10px"
				:disabled="wooLoading || !connected || !apiKeyValid"
				:saving="wooLoading"
				:failed="requestFail"
			>
				{{
					showWooSettings ? 'Connect WooCommerce' : 'Auto-Generate Keys + Connect WooCommerce'
				}} </core-save-button
			><span v-if="showWooSettings && !wooLoading"
				>or <a href="#" @click.prevent="hideWooSettingsAndAutogenerate">autogenerate and connect</a>.</span
			>

			<p v-if="!showWooSettings && !wooLoading">
				or <a href="#" @click.prevent="toggleshowWooSettings">click here</a> to enter the consumer key/secret
				pair manually.
			</p>
		</form>
		<form v-else @submit.prevent="disconnect">
			<core-alert type="success" icon="success" class="omapi-settings-page__plugin-connected">
				<div class="alert-message">
					WooCommerce is currently connected to OptinMonster{{ wooKey.id ? ' with the following key:' : '!' }}
				</div>
			</core-alert>
			<p v-if="wooKey.id">
				<code>{{ wooKey.description }} (&hellip;{{ wooKey.truncated }})</code>&nbsp;&nbsp;<a
					:href="wooKey.editUrl"
					>Edit key</a
				>
			</p>
			<p>
				To remove your keys from OptinMonster, or to change the consumer key/secret pair associated with
				OptinMonster, you need to disconnect WooCommerce, below.
			</p>
			<core-save-button
				size="large"
				:color="wooLoading ? '' : 'blue'"
				style="margin-bottom: 10px"
				:disabled="wooLoading || !connected || !apiKeyValid"
				:saving="wooLoading"
				:failed="requestFail"
			>
				Disconnect WooCommerce
			</core-save-button>
		</form>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	data() {
		return {
			showWooSettings: false,
			requestFail: false,
			key: '',
			secret: '',
		};
	},
	computed: {
		...mapState(['error', 'apiKeyValid']),
		...mapGetters(['connected', 'showProUpsells', 'userPlanName']),
		...mapGetters('wp', ['isWooConnected', 'wooKey']),
		wooLoading() {
			return this.$store.getters.isLoading('wooconnect');
		},
	},
	watch: {
		isWooConnected() {
			this.requestFail = false;
		},
		error(val) {
			if (!val) {
				this.requestFail = false;
			}
		},
	},
	mounted() {
		this.autoFetchWooKey();
	},
	methods: {
		...mapActions('wp', ['autogenerateWooCreds', 'saveWooCreds', 'fetchWooKey', 'disconnectWoo']),
		toggleshowWooSettings() {
			this.showWooSettings = !this.showWooSettings;
		},
		hideWooSettingsAndAutogenerate() {
			this.showWooSettings = false;
			this.autogenerate();
		},
		connectWoo() {
			this.$store.commit('clearAlerts');
			this.requestFail = false;
			return this.showWooSettings ? this.connect() : this.autogenerate();
		},
		autogenerate() {
			this.requestFail = false;

			this.autogenerateWooCreds().catch(() => {
				this.showWooSettings = true;
				this.requestFail = true;
			});
		},
		connect() {
			this.requestFail = false;
			this.saveWooCreds({
				key: this.key,
				secret: this.secret,
			}).catch(() => {});
		},
		disconnect() {
			this.$store.commit('clearAlerts');
			this.requestFail = false;
			this.disconnectWoo();
		},
		autoFetchWooKey() {
			if (!this.wooKey.id) {
				this.fetchWooKey().catch(() => {});
			}
		},
	},
};
</script>
